<div class="modal-overlay" *ngIf="isOpen" (click)="closeModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ title }}</h2>
      <button class="close-button" (click)="closeModal()">&times;</button>
    </div>
    
    <div class="modal-body">
      <div class="icon-container">
        <div class="success-icon">&#10004;</div>
      </div>
      <p class="modal-message">{{ message }}</p>
      
      <div class="file-info" *ngIf="fileName">
        <div class="file-icon">📄</div>
        <span class="file-name">{{ fileName }}</span>
      </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn btn-cancel" (click)="closeModal()">Cancelar</button>
      <button class="btn btn-download" (click)="confirmDownload()">
        <span class="download-icon">⬇</span>
        Descargar
      </button>
    </div>
  </div>
</div>
